<template>
    <div>
        <!-- 面包屑导航 -->
        <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
        <!-- 面包屑导航 -->
        <!-- 查询 -->
        <div class="content">
            <h2>关联小程序</h2>
            <h3>数据筛选</h3>
            <div>
                <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
                    <el-form-item label="小程序名称" prop="name">
                        <el-input v-model="searchForm.name" placeholder="请输入小程序名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="原始ID" prop="nickName">
                        <el-input style="width: 215px" v-model="searchForm.originId" placeholder="请输入原始ID"></el-input>
                    </el-form-item>
                    <el-form-item label="商户号" prop="phone">
                        <el-input style="width: 215px" v-model="searchForm.mchId" placeholder="请输入商户号"></el-input>
                    </el-form-item>
                    <el-form-item label="关联时间" prop="joinTimeStart">
                        <el-date-picker v-model="value1" style="width: 232px" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="绑定时间" prop="joinTimeStart">
                        <el-date-picker v-model="value2" style="width: 232px" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <div style="display: flex; margin-top: 4px">
                            <div class="btn-search" @click="fetchData('search')">查询</div>
                            <div class="btn-search" style="margin-left: 20px" @click="fetchData('reset')">
                                重置
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
                <div style="height:20px"></div>
            </div>
        </div>
        <div class="content">
            <div class="title">
                <h3>列表数据</h3>
                <div>
                    <div class="derive" @click="add('add')">新增关联小程序</div>
                    <!-- <el-button type="primary" @click="add"
                        style="background-color: #4168E7;border:1px solid #4168E7">新增关联小程序</el-button> -->
                </div>
            </div>
            <div id="base-list">
                <lb-table v-loading="loading" v-horizontal-scroll="'always'" :column="columns" :data="page.list" pagination
                    :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper"
                    :page-sizes="[5, 10, 20, 30, 50]" :current-page.sync="searchForm.pageNo"
                    :page-size="searchForm.pageSize" @selection-change="onMultipleSelection" @size-change="handleSizeChange"
                    @p-current-change="handleCurrentChange">
                </lb-table>
            </div>
        </div>
        <el-dialog :title="title" :visible.sync="isAdd" width="30%" :append-to-body="true" :close-on-click-modal="false">
            <div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" size="small" class="ruleForm">
                    <el-form-item label="小程序名称" prop="name">
                        <el-input v-model="ruleForm.name" placeholder="请输入小程序名称"></el-input>
                    </el-form-item>
                    <el-form-item label="原始ID" prop="originId">
                        <el-input v-model="ruleForm.originId" placeholder="请输入原始ID"></el-input>
                    </el-form-item>
                    <el-form-item label="AppID(小程序ID)" prop="appid">
                        <el-input v-model="ruleForm.appid" placeholder="请输入小程序ID"></el-input>
                    </el-form-item>
                    <el-form-item label=" 小程序密钥" prop="appSecret">
                        <el-input v-model="ruleForm.appSecret" placeholder="请输入小程序密钥"></el-input>
                    </el-form-item>
                    <el-form-item label="腾讯广告数据源ID" prop="userActionSetId">
                        <el-input v-model="ruleForm.userActionSetId" placeholder="请输入腾讯广告数据源ID"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div style="display: flex; justify-content: end; margin-top: 24px">
                <div class="info-q" @click="isAdd = false">取消</div>
                <div class="info-s" @click="submit">确定</div>
            </div>
        </el-dialog>
        <el-dialog title="提示信息" :visible.sync="isInfo" width="643px" :append-to-body="true" :close-on-click-modal="false"
            custom-class="infoI">
            <div slot="title">
                <div><i class="el-icon-warning" style="font-size: 22px;color:#edb840"></i><span
                        style="fontSize: 22px;">提示信息</span></div>
            </div>
            <div v-if="info1 == '0'">删除后不可恢复数据，是否继续？</div>
            <div v-if="info1 == '1'">绑定后将自动停用原商户号，是否绑定？</div>
            <div v-if="info1 == '2'">删除绑定后将不再绑定商户号，是否继续？</div>
            <div v-if="info1 == '3'">确认是否绑定该商户号？</div>
            <div style="display: flex; justify-content: end; margin-top: 24px">
                <div class="info-q" @click="isInfo = false">取消</div>
                <div class="info-s" @click="submitI">确定</div>
            </div>
        </el-dialog>
        <el-dialog title="绑定商户号" :visible.sync="isBind" width="40%" :append-to-body="true">
            <template>
                <div>
                    <div>
                        <el-table :data="list" ref="multipleTable" :header-cell-style="{
                            'text-align': 'left',
                            background: '#F8F8F8',
                            color: '#333333',
                        }">
                            <el-table-column prop="name" label="商户号名称">

                            </el-table-column>
                            <el-table-column prop="mchId" label="商户号">

                            </el-table-column>
                            <el-table-column prop="name" label="状态">
                                <template slot-scope="scope">
                                    <p>{{ scope.row.statusLabel }}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="100">
                                <template slot="header" slot-scope="scope">
                                    <div style="text-align: center;">操作</div>
                                </template>
                                <template slot-scope="scope">
                                    <div style="text-align: center;">
                                        <div v-if="scope.row.isB == true" class="red" style="cursor: pointer;"
                                            @click="changeB('2', scope.row, scope.$index)">删除绑定</div>
                                        <div v-else style="color:#4168E7;cursor: pointer;"
                                            @click="changeB('1', scope.row, scope.$index)">绑定
                                        </div>
                                    </div>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div style="display: flex; justify-content: end; margin-top: 24px">
                    <!-- <div class="info-q" @click="isBind = false">取消</div> -->
                    <!-- <div class="info-s" @click="isBind = false">确定</div> -->
                </div>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
    components: {
        breadcrumbTop,
        LbTable
    },
    data() {
        return {
            cIndex: '',
            appId: '',
            mchId: '',
            info1: '',
            isInfo: false,
            value1: [],
            value2: [],
            isAdd: false,
            isBind: false,
            ruleForm: {
                id: '',
                name: '',
                originId: '',
                appid: '',
                appSecret: '',
                userActionSetId: '',
                platformId: ''
            },
            rules: {
                name: [
                    { required: true, message: '请输入小程序名称', trigger: 'blur' }
                ],
                originId: [
                    { required: true, message: '请输入原始ID', trigger: 'blur' }
                ],
                appid: [
                    { required: true, message: '请输入小程序ID', trigger: 'blur' }
                ],
                appSecret: [
                    { required: true, message: '请输入小程序密钥', trigger: 'blur' }
                ],
            },
            payTime: [],
            dataList: {
                list: [
                    { title: '矩阵管理', path: '', type: '0' },
                    { title: '平台列表', path: '', type: '1' }
                ]
            },
            searchForm: {
                pageNo: 1,
                pageSize: 10,
                name: '',
                originId: '',
                mchId: '',
                createdTimeStart: '',
                createdTimeEnd: '',
                bindTimeStart: '',
                bindTimeEnd: '',
                platformId: ''
            },
            list: [

            ],
            columns: [
                { label: '小程序名称', prop: 'name', minWidth: '120' },
                { label: '原始ID', prop: 'originId', minWidth: '200' },
                { label: '小程序ID', prop: 'appid', minWidth: '200' },
                { label: '小程序密钥', prop: 'appSecret', minWidth: '200' },
                { label: '腾讯广告数据源ID', prop: 'userActionSetId', minWidth: '200' },

                { label: '关联时间', prop: 'createdTime', minWidth: '200' },
                { label: '绑定商户号', prop: 'mchMchId', minWidth: '200' },
                {
                    label: '商户号名称', prop: 'mchName', minWidth: '200',

                },
                {
                    label: '绑定时间', prop: 'mchBindedTime', minWidth: '200',
                },
                {
                    label: '操作',
                    minWidth: '200',
                    fixed: 'right',
                    render: (h, scope) => {
                        return (
                            <div>

                                <span style='color:#4168E7;cursor:pointer' onClick={() => { this.add('edit', scope.row) }}>编辑</span>
                                <span style='color:#4168E7;cursor:pointer;margin-left:10px;margin-right:10px' onClick={() => { this.bind(scope.row) }}>绑定商户号</span>
                                <span style='color:#4168E7;cursor:pointer' onClick={() => { this.delete(scope.row.id) }}>删除</span>
                            </div >
                        )
                    }
                }],
            page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
            dictionaries: {},
            loading: true,
            platformList: [],
            title: '新增小程序',
            isFirst: false,
        }
    },
    created() {
        this.getDictionaries('platform_vip_level')
        this.fetchData()
        // this.goodsPlatforms()
    },
    methods: {
        submitI() {
            if (this.info1 == 0) {
                let data = {
                    id: this.appId
                }
                this.axios.post('/ps/platforms/miniApp/delete', data).then(res => {
                    if (res.code == 0) {
                        this.isInfo = false
                        this.$message.success('删除成功')
                        this.fetchData()

                    } else {
                        this.$message.error(res.message)
                    }
                })
            } else if (this.info1 == 1 || this.info1 == 3) {
                let data = {
                    id: this.appId,
                    mchId: this.mchId
                }
                this.axios.post('/ps/platforms/miniApp/bindingMch', data).then(res => {
                    if (res.code == 0) {
                        this.isInfo = false
                        this.$message.success('绑定成功')
                        this.list.forEach(item => {
                            if (item.id == this.list[this.cIndex].id) {
                                item.isB = true
                            } else {
                                item.isB = false
                            }
                        })
                        // this.list[this.cIndex].isB = true
                        this.fetchData()
                        this.$forceUpdate()
                    } else {
                        this.$message.error(res.message)
                    }
                })
            } else {
                let data = {
                    id: this.appId,
                    mchId: this.mchId
                }
                this.axios.post('/ps/platforms/miniApp/cancelBindedMch', data).then(res => {
                    if (res.code == 0) {
                        this.isInfo = false
                        this.$message.success('删除绑定成功')
                        this.list.forEach(item => {
                            item.isB = false
                        })
                        // this.list[this.cIndex].isB = false
                        this.fetchData()
                        this.$forceUpdate()
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }
        },
        changeB(val, row, index) {
            this.info1 = val
            this.isFirst = this.list.some(item => item.isB == true)
            if (this.info1 == 1 && !this.isFirst) {
                this.info1 = 3
            }
            this.isInfo = true
            this.mchId = row.id
            this.cIndex = index
        },
        submit() {
            this.ruleForm.platformId = this.$route.query.id
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.axios.post('/ps/platforms/miniApp/saveInfo', this.ruleForm).then(res => {
                        if (res.code == 0) {
                            if (this.title == '新增小程序') {
                                this.$message({
                                    type: 'success',
                                    message: '添加成功'
                                })

                            } else {
                                this.$message({
                                    type: 'success',
                                    message: '编辑成功'
                                })

                            }
                            this.isAdd = false
                            this.fetchData()

                        } else {
                            this.$message.error(res.message)
                        }
                    })
                }
            });
        },
        add(val, row) {
            this.isAdd = true
            this.$nextTick(() => {
                if (this.$refs.ruleForm) {
                    this.$refs['ruleForm'].resetFields();
                }

            })
            if (val == 'add') {
                this.title = "新增小程序"
                this.ruleForm.id = ''
            } else {
                this.title = "编辑小程序"

                this.getD(row.id)
            }

        },
        getD(id) {
            this.axios.get('/ps/platforms/miniApp/getInfo?id=' + id).then(res => {
                if (res.code == 0) {
                    this.ruleForm = res.data

                } else {
                    this.$message.error(res.message)
                }
            })
        },
        bind(row) {
            this.isBind = true
            this.appId = row.id
            this.axios.get('/ps/platform/mch/getAllMchList').then(res => {
                if (res.code == 0) {
                    res.data.forEach(item => {
                        if (item.mchId == row.mchMchId) {
                            item.isB = true
                        } else {
                            item.isB = false
                        }
                    })
                    this.list = res.data

                } else {
                    this.$message.error(res.message)
                }
            })
        },
        delete(id) {
            this.info1 = '0'
            this.isInfo = true
            this.appId = id
            // const msg = `删除后不可恢复数据，是否继续？`
            // this.$confirm(msg, '提示', {
            //     title: '提示信息',
            //     confirmButtonText: '确定',
            //     cancelButtonText: '取消',
            //     type: 'error'
            // }).then(() => {
            //     const params = { id: id }
            //     // this.$api.deletePsCoupon(params).then((res) => {
            //     //     this.getList()
            //     //     this.$message({ type: 'success', message: '操作成功!' })
            //     // }).catch((err) => {
            //     //     console.log(err)
            //     // })
            // }).catch(() => {
            //     // this.$message({
            //     //     type: 'info',
            //     //     message: '已取消'
            //     // })
            // })
        },
        //导出
        deriveDeliver() {
            this.$api.exportCommissionListA(this.searchForm).then(res => {
                if (res.code == 0) {
                    this.downloadlink(res.data)
                    this.$message({
                        type: 'success',
                        message: '导出成功!'
                    })
                }
            })
        },
        downloadlink(url) {
            const iframe = document.createElement('iframe')
            iframe.style.display = 'none'
            iframe.src = url
            document.body.appendChild(iframe)
        },
        goodsPlatforms() {
            const params = {
                userId: null,
                username: null,
                phone: null,
                vipLevel: null,
                categoryIds: null,
                openTimeStart: null,
                openTimeEnd: null,
                status: 1
            }
            this.$api.goodsPlatforms(params).then((res) => {
                res.data.forEach(item => {
                    if (item.name !== '五域') {
                        this.platformList.push(item)
                    }
                })
                // this.platformList = res.data
            }).catch((err) => {
                console.log(err)
            })
        },
        // 获取字典数据
        getDictionaries(type) {
            const params = { groupId: type }
            this.$api.dictionaries(params).then((res) => {
                this.dictionaries['platform_vip_level'] = res.data
            }).catch((err) => {
                console.log(err)
            })
        },
        onMultipleSelection(val) {
            this.selectionGoods = val
        },
        handleCurrentChange(currentChange) {
            this.searchForm.pageNo = currentChange
            this.fetchData()
        },
        handleSizeChange(sizeChange) {
            this.searchForm.pageSize = sizeChange
            this.fetchData()
        },
        fetchData(type) {
            if (type == 'reset') {
                this.searchForm = {}
                this.searchForm.pageNo = 1
                this.searchForm.pageSize = 10
                this.value1 = []
                this.value2 = []
            }
            if (type == 'search') {
                this.searchForm.pageNo = 1
                this.searchForm.pageSize = 10
            }
            this.searchForm.platformId = this.$route.query.id
            if (this.value1) {
                this.searchForm.createdTimeStart = this.value1[0]
                this.searchForm.createdTimeEnd = this.value1[1]
            } else {
                this.searchForm.createdTimeStart = ''
                this.searchForm.createdTimeEnd = ''
            }
            if (this.value2) {
                this.searchForm.bindTimeStart = this.value2[0]
                this.searchForm.bindTimeEnd = this.value2[1]
            } else {
                this.searchForm.bindTimeStart = ''
                this.searchForm.bindTimeEnd = ''
            }
            this.axios.post('/ps/platforms/miniApp/getMiniAppPageList', this.searchForm).then(res => {
                if (res.code == 0) {
                    res.data.list.forEach(item => {
                        item.userActionSetId = item.userActionSetId || '--'
                        item.mchMchId = item.mchMchId || '--'
                        item.mchBindedTime = item.mchBindedTime || '--'
                        item.mchName = item.mchName || '--'
                    })
                    this.page.list = res.data.list
                    this.page.totalNum = res.data.totalNum
                    this.loading = false
                }
            })
        },
        // add() {
        //     this.$router.push({
        //         name: 'platListDetail',
        //         query: {}
        //     })
        // },
        setting() {
            this.$router.push({
                name: 'settingPlatform',
                query: {}
            })
        },
        todetail(row) {
            this.$router.push({
                name: 'commissionManageDetail',
                query: {
                    platformId: row.platformId
                }
            })
        }
    }
}
</script>
<style lang="scss">
.infoI {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);

    .el-dialog__header {
        background-color: #ffffff;
        border-bottom: none !important
    }

    .el-dialog__body {
        // padding: 30px 25px;
        // height: 800px;
        flex: 1;
        overflow: auto;
    }

}
</style>
<style scoped lang="scss">
.info-q {
    width: 120px;
    height: 36px;
    line-height: 36px;
    background: #ffffff;
    border: 1px solid #D9D9D9;
    opacity: 1;
    border-radius: 4px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 18px;
    cursor: pointer;
}

.info-s {
    width: 120px;
    height: 36px;
    line-height: 36px;
    background: #4168E7;
    opacity: 1;
    border-radius: 4px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}

.red {
    color: #ff0000;
}

.green {
    color: #67c23a;
}

.btn-search {
    width: 68px;
    height: 32px;
    background: #e3edff;
    opacity: 1;
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 32px;
    color: #4168e7;
    text-align: center;
    cursor: pointer;
}

.derive {
    width: 168px;
    height: 36px;
    background: #4168E7;
    opacity: 1;
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 36px;
    color: #FFFFFF;
    text-align: center;
    cursor: pointer;
}

.container {
    background-color: #fff;
    width: 100%;
    height: 100%;
    padding: 5px;
}

.title {
    display: flex;
    justify-content: space-between;
}

#base-list {
    margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
    display: inline-block;

    a {
        margin: 0 5px;
    }
}
</style>
  
  